
export const Layers = [
    'size', 'flavor', 'finish', 'decor'
];

export const LayerTitles = {
    'size': '1. Größe',
    'flavor': '2. Geschmack',
    'finish': '3. Optik',
    'decor': '4. Dekor'
};



// WEBPACK FOOTER //
// ./js/cake/Layers.js